function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m241 106c0 24.813 20.187 45 45 45h15v60h90v-45c0-8.271 6.729-15 15-15s15 6.729 15 15v45h91v-211h-211v61h-15c-24.813 0-45 20.187-45 45zm45-15h45v-61h151v151h-31v-15c0-24.813-20.187-45-45-45s-45 20.187-45 45v15h-30v-60h-45c-8.271 0-15-6.729-15-15s6.729-15 15-15z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m391 301h-60v-15c0-24.813-20.187-45-45-45s-45 20.187-45 45v15h-30v-60h-45c-8.271 0-15-6.729-15-15s6.729-15 15-15h45v-90h-211v391h391zm-361-150h151v30h-15c-24.813 0-45 20.187-45 45s20.187 45 45 45h15v30h-60v45c0 8.271-6.729 15-15 15s-15-6.729-15-15v-45h-61zm151 331h-151v-151h31v15c0 24.813 20.187 45 45 45s45-20.187 45-45v-15h30v60h45c8.271 0 15 6.729 15 15s-6.729 15-15 15h-45zm180 0h-150v-31h15c24.813 0 45-20.187 45-45s-20.187-45-45-45h-15v-30h60v-45c0-8.271 6.729-15 15-15s15 6.729 15 15v45h60z"
}));

var SvgPuzzles = function SvgPuzzles(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPuzzles, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Puzzles.55515a3c.svg";
export { ForwardRef as ReactComponent };